import { Fragment, type FC } from 'react';

import { OperationTypesEnum } from '../constants/singleFlow.js';
import type { ApprovalSequenceType } from '../types/singleFlow.js';
import LogicalGroup from './LogicalGroup.jsx';
import Separator from './Separator.jsx';

type Props = {
  items: ApprovalSequenceType;
};

const ApprovalSequence: FC<Props> = ({ items }) => {
  return (
    <div className="grid w-full gap-4">
      {items.map((logicalGroup, index) => {
        return (
          <Fragment key={JSON.stringify(logicalGroup)}>
            {index === 0 ? null : (
              <Separator variant={OperationTypesEnum.enum.then} />
            )}
            <LogicalGroup items={logicalGroup} />
          </Fragment>
        );
      })}
    </div>
  );
};

export default ApprovalSequence;
